module.exports = __webpack_public_path__ + "img/progress-bar-primary.svg?2b75007a55e85c43bf665efff5302c85";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/img/progress/progress-bar-primary.svg
// module id = 264
// module chunks = 0